import companyPaths from '@features/company/paths';

export const dashboardPaths = {
    default: '/dash',
    exploreNotes: '/notes/explore',
    company: companyPaths
}

export default dashboardPaths;